import { fork } from 'redux-saga/effects'

import { authSaga } from './auth'
import { userSaga } from './user'
import { inviteSaga } from './invite'
import { marketSaga } from './market'
import { tagSaga } from './tag'
import { onboardingSaga } from './onboarding'
import { paymentSaga } from './payment'
import { mcPaymentSaga } from './mcPayment'
import { contractorSaga } from './contractor'
import { activitiesSaga } from './activities'
import { noteSaga } from './note'
import { customerSaga } from './customer'
import { mcOnboardingSaga } from './mc-onboarding'
import { mcSaga } from './mc'
import { teamSaga } from './team'
import { subcontractorRequestsSaga } from './subcontractorRequests'
import { linkSubcontractorSaga } from './linkSubcontractor'
import { mcLiteSaga } from './mcLite'
import { fileSaga } from './file'
import { rejectionReasonsSaga } from './rejectionReasons'

export function* rootSaga() {
  yield fork(authSaga)
  yield fork(userSaga)
  yield fork(inviteSaga)
  yield fork(tagSaga)
  yield fork(marketSaga)
  yield fork(contractorSaga)
  yield fork(paymentSaga)
  yield fork(mcPaymentSaga)
  yield fork(onboardingSaga)
  yield fork(activitiesSaga)
  yield fork(teamSaga)
  yield fork(noteSaga)
  yield fork(customerSaga)
  yield fork(mcSaga)
  yield fork(mcOnboardingSaga)
  yield fork(subcontractorRequestsSaga)
  yield fork(linkSubcontractorSaga)
  yield fork(mcLiteSaga)
  yield fork(fileSaga)
  yield fork(rejectionReasonsSaga)
}
